import { IOrganisation, IOrganisationForm, ISaveOrganisation, Day } from '../../shared';

export const organisationToFormMapper = (item: IOrganisation): IOrganisationForm => {
    return {
        ...item,
        name: item.name,
        type: item.type.id,
        shipmentDays: item.shipmentDays.map((day) => day.toString()),
    };
};

export const organisationFromFormMapper = (item: IOrganisationForm): ISaveOrganisation => {
    return {
        ...item,
        shipmentDays: item.shipmentDays.map((day) => Number(day) as Day),
        address: {
            street: item.address?.street || '',
            number: item.address?.number || '',
            postalCode: item.address?.postalCode || '',
            city: item.address?.city || '',
            country: item.address?.country || '',
        },
    };
};
